import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectStatuses = state => selectState(state).data;
export const selectStatusLoading = state => selectState(state).loading;
export const selectStatusError = state => selectState(state).error;

export const selectProcessStatuses = state => selectState(state).processdata;
export const selectProcessStatusLoading = state => selectState(state).processloading;
export const selectProcessStatusError = state => selectState(state).processerror;
